<template>
  <div>
    <!-- MENSAJES -->
    <mensajeSistema></mensajeSistema>

    <!-- SELECTS (FILTROS) Y BOTÓN BUSCAR -->
    <template>
      <v-row>
        <v-col>
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-on="on"
                v-model="computedDateFormatted"
                label="Fecha de Asistencias"
                v-bind="attrs"
                prepend-icon="mdi-calendar"
                readonly
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="datePicked"
              :allowed-dates="allowedDays"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col>
          <v-select
            @change="SeleccionarNivel(nivelSelected)"
            v-model="nivelSelected"
            label="Nivel"
            :items="niveles"
            item-text="desc_nivel"
            item-value="id_nivel_adm"
          ></v-select>
        </v-col>

        <v-col>
          <v-select
            @change="SeleccionarGrado(gradoSelected)"
            v-model="gradoSelected"
            :items="grados"
            label="Grado"
            item-text="desc_grado"
            item-value="id"
          >
          </v-select>
        </v-col>

        <v-col>
          <v-select
            @change="SeleccionarSeccion(seccionSelected)"
            v-model="seccionSelected"
            label="Sección"
            :items="secciones"
            item-text="nombre_seccion"
            item-value="id"
          >
          </v-select>
        </v-col>

        <v-col>
          <v-select
            @change="SeleccionarEstudiante(estudianteSelected)"
            v-model="estudianteSelected"
            label="Estudiante"
            :items="estudiantesfiltrado"
            item-text="full_name"
            item-value="id_alumno"
          >
          </v-select>
        </v-col>

        <v-col class="d-flex align-center">
          <template>
            <v-btn @click="buscarAsistenciasEstudiantes()" color="success">
              BUSCAR&nbsp; <v-icon class="fas fa-search"> </v-icon>
            </v-btn>
          </template>
        </v-col>
      </v-row>
    </template>

    <!-- LIMPIAR FILTROS -->
    <v-row>
      <v-col cols="6" class="d-flex justify-space-between">
        <template>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="LimpiadorFiltrosTable()"
                v-on="on"
                v-bind="attrs"
                small
              >
                <v-icon class="fas fa-redo green--text"></v-icon>
              </v-btn>
            </template>
            <span>Limpiar filtros</span>
          </v-tooltip>
        </template>
      </v-col>
    </v-row>

    <!-- TABLA Y EL HEADER -->
    <v-row>
      <v-col>
        <v-data-table :items="estudiantes" :headers="dinamicHeader">
          <!-- Asistencia del dia seleccionado -->
          <template v-slot:item.id_estado_asistencia="props">
            <v-select
              v-model="props.item.id_estado_asistencia"
              :items="estadosAsistencias"
              label="Asistencia de Hoy"
              item-value="id"
              item-text="desc_estado"
              @change="
                editDailyAttendance(
                  props.item.id,
                  props.item.id_estado_asistencia
                )
              "
            ></v-select>
          </template>

          <!-- Justificado de asistencias --->
          <template v-slot:item.charge_justified="props">
            <v-btn
              class="mx-2 btn_editar"
              fab
              x-small
              @click="openModalJustified(props.item)"
            >
              <v-icon>fa-file-upload</v-icon>
            </v-btn>
          </template>

          <!-- Descargar justificado --->
          <template v-slot:item.documento_justificado="props">
            <v-btn
              class="mx-2 btn_otro"
              fab
              x-small
              :disabled="props.item.documento_justificado == null"
              @click="
                download(URL_SPACE + '/' + props.item.documento_justificado)
              "
            >
              <v-icon>fa-file-download</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- MODAL PARA CARGAR EL DOCUMENTO JUSTIFICATIVO  --->
    <v-form lazy-validation>
      <v-dialog v-model="dialogJustificado" scrollable max-width="40%">
        <v-card>
          <v-card-title class="modal_title py-5 mb-2"
            >Adjuntar justificado</v-card-title
          >

          <v-col class="py-0">
            <v-file-input
              label="Cargar archivo"
              accept=".docx, .pdf, .doc"
              v-model="archivoSubir"
            >
            </v-file-input>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="btn_style3" @click="dialogJustificado = false">
                Cancelar
              </v-btn>
              <v-btn
                class="btn_block_style2"
                dark
                
                @click="guardarJustificativo"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-col>
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script>
import axios from "@/helpers/axios";
import { mapMutations, mapState } from "vuex";
import { BUCKET_ORIGIN_SPACE } from "@/helpers/axios";

export default {
  data: () => ({
    //--Arrays
    niveles: [],
    grados: [],
    secciones: [],
    estudiantesOriginales: [],
    estudiantes: [],
    estudiantesfiltrado: [],
    estadosAsistencias: [],
    id_colegio: "",
    id_ano_lectivo: "",
    dialog: false,
    datePicked: "",
    datePickedHeader: "",

    //--Filtros Seleccionados
    nivelSelected: "",
    gradoSelected: "",
    seccionSelected: "",
    estudianteSelected: "",

    //----- Dias en los que el estudiante ira al colegio
    allowedDaysR: [],

    //Descargar archivos del SPACE
    URL_SPACE: BUCKET_ORIGIN_SPACE,

    //Justificados
    dialogJustificado: null,
    archivoSubir: null,
    estudianteActual: "",
  }),

  methods: {
    //Peticiones al back
    async getNiveles() {
      try {
        const response = await axios.post(
          "/academico/asistenciaColegioNew/getNiveles",
          {
            id_colegio: this.id_colegio,
            id_ano_lectivo: this.id_ano_lectivo,
          }
        );

        this.niveles = response.data;
      } catch (error) {
        console.log(error);
      }
    },

    async getGrados(nivelSelected) {
      try {
        const response = await axios.post(
          "/academico/asistenciaColegioNew/getGrados",
          {
            id_colegio: this.id_colegio,
            id_ano_lectivo: this.id_ano_lectivo,
            idNivel: nivelSelected,
          }
        );

        this.grados = response.data;
      } catch (error) {
        console.log(error);
      }
    },

    async getSecciones(gradoSelected) {
      try {
        const response = await axios.post(
          "/academico/asistenciaColegioNew/getSecciones",
          {
            id_colegio: this.id_colegio,
            id_ano_lectivo: this.id_ano_lectivo,
            idGrado: gradoSelected,
          }
        );

        this.secciones = response.data;
      } catch (error) {
        console.log(error);
      }
    },

    async getEstudiantes(idSeccion) {
      try {
        const response = await axios.post(
          "/academico/asistenciaColegioNew/getHistorialAsistencias",
          {
            id_colegio: this.id_colegio,
            id_ano_lectivo: this.id_ano_lectivo,
            id_seccion: idSeccion,
            fecha_asistencia: this.datePicked,
            id_estudiante: this.estudianteSelected,
          }
        );

        if (response.data.length == 0) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: "No se encontrarón registros de asistencias en esa fecha.",
            tiempo: 4000,
          });
        }

        this.estudiantes = response.data;
      } catch (error) {
        console.log(error);
      }
    },

    async getEstudiantesFilter(idSeccion) {
      try {
        const response = await axios.post(
          "/academico/asistenciaColegioNew/getEstudiantes",
          {
            id_colegio: this.id_colegio,
            id_seccion: idSeccion,
            id_ano_lectivo: this.id_ano_lectivo,
            fecha_asistencia: this.datePicked,
          }
        );

        this.estudiantesfiltrado = response.data;
        console.log(this.estudiantesfiltrado)
      } catch (error) {
        console.log(error);
      }
    },

    async getEstudiantesHistorial() {
      try {
        const response = await axios.post(
          "/academico/asistenciaColegioNew/getHistorialAsistencias",
          { id_colegio: this.id_colegio, id_ano_lectivo: this.id_ano_lectivo }
        );
        console.log(response.data);
        this.estudiantes = response.data;
        this.estudiantesOriginales = response.data;
      } catch (error) {
        console.log(error)
        this.setEnviarMens({
          tipo: 'E',
          mensaje: 'Error al traer el historial de los estudiantes.'
        })
      }
    },

    async getAsistenciasEstados() {
      try {
        const response = await axios.post(
          "/academico/asistenciaColegioNew/getEstadosAsistencias"
        );
        this.estadosAsistencias = response.data;
      } catch (e) {
        console.log(e);
        this.setEnviarMens({
          tipo: 'E',
          mensaje: 'Error al traer el estado de las asistencias.'
        })
      }
    },

    async editDailyAttendance(id_asistencia, id_estado_asistencia) {
      try {
        console.log(id_asistencia, id_estado_asistencia);

        const response = await axios.put(
          "/academico/asistenciaColegioNew/updateDailyAttendance",
          {
            id_asistencia,
            id_estado_asistencia,
          }
        );

        this.setEnviarMens({
          tipo: response.data.messageT,
          mensaje: response.data.message,
          tiempo: 2000,
        });
      } catch (error) {
        console.log(
          "Hubo un error al momento de guardar las asistencias al colegio" +
            error
        );
      }
    },

    async guardarJustificativo() {
      try {
        const formData = new FormData();

        formData.append("id_asistencia", this.estudianteActual.id.toString());
        formData.append("subirArchivo", this.archivoSubir);

        if (!this.archivoSubir) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `Debe subir un archivo`,
            tiempo: 2000,
          });
        } else {
          const response = await axios.post(
            "/academico/asistenciaColegioNew/insertDailyJustified",
            formData
          );

          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: 5000,
          });

          this.dialogJustificado = false;
          this.archivoSubir = null;
          this.buscarAsistenciasEstudiantes();
        }
      } catch (error) {
        console.log(error);
        this.setEnviarMens({
          tipo: 'E',
          mensaje: 'Error al guardar el justificativo.'
        })
      }
    },

    //Disparadores
    SeleccionarNivel(nivelSelected) {
      this.LimpiadorFiltros();

      this.nivelSelected = nivelSelected;
      this.getGrados(nivelSelected);
    },

    SeleccionarGrado(gradoSelected) {
      this.getSecciones(gradoSelected);
    },

    SeleccionarSeccion(idSeccion) {
      this.seccionSelected = idSeccion;
      if (this.datePicked == "") {
        this.setEnviarMens({
          tipo: "W",
          mensaje: "Debe seleccionar primero una fecha.",
          tiempo: 5000,
        });
      } else {
        this.getEstudiantesFilter(idSeccion);
      }
    },

    SeleccionarEstudiante(idEstudiante) {
      this.estudianteSelected = idEstudiante;

    },

    buscarAsistenciasEstudiantes() {
      let idSeccion = this.seccionSelected;

      if (idSeccion == "") {
        this.setEnviarMens({
          tipo: "W",
          mensaje: "Debe seleccionar una sección",
          tiempo: 5000,
        });
      } else if (this.datePicked == "") {
        this.setEnviarMens({
          tipo: "W",
          mensaje: "Debe seleccionar una fecha",
          tiempo: 5000,
        });
      } else {
        this.getEstudiantes(idSeccion);
        this.datePickedHeader = this.datePicked;
      }
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    //Descargar justiticativo
    async download(url) {
      console.log(url);
      await this.$Files["downloadFetch"]({ url });
      //Añadir un manejador de errores
    },

    //Limpiadores
    LimpiadorFiltros() {
      this.nivelSelected = [];
      this.grados = [];
      this.secciones = [];
      this.estudiantesfiltrado = [];
      this.gradoSelected = "";
      this.seccionSelected = "";
      this.estudianteSelected = "";
    },

    LimpiadorFiltrosTable() {
      this.estudiantes = [];
      this.nivelSelected = [];
      this.grados = [];
      this.secciones = [];
      this.estudiantesfiltrado = [];
      this.gradoSelected = "";
      this.seccionSelected = "";
      this.estudianteSelected = "";
      this.datePicked = "";
    },

    //Mensajes de Alertas
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    allowedDays: function (date) {
      return this.allowedDaysR.includes(date);
    },
  },

  computed: {
    ...mapState(["diasEscolaresColegio"]),

    diasEscolares() {
      return this.$store.state.diasEscolaresColegio;
    },

    computedDateFormatted() {
      return this.formatDate(this.datePicked);
    },

    dinamicHeader() {
      return [
        {
          text: "Nombre completo",
          value: "full_name",
          class: "secondary black--text",
        },
        {
          text: "DNI",
          value: "numdoc_persona",
          class: "secondary black--text",
        },
        { text: "Nivel", value: "desc_nivel", class: "secondary black--text" },
        { text: "Grado", value: "desc_grado", class: "secondary black--text" },
        {
          text: "Sección",
          value: "nombre_seccion",
          class: "secondary black--text",
        },
        {
          text: `Asistencia ${this.datePickedHeader}`,
          value: "id_estado_asistencia",
          class: "secondary black--text",
        },
        {
          text: `Cargar justificado`,
          value: `charge_justified`,
          class: `secondary black--text`,
        },
        {
          text: `Descargar justificado`,
          value: `documento_justificado`,
          class: `secondary black--text`,
        },
      ];
    },
  },

  mounted() {
    this.id_colegio = sessionStorage.getItem("id_colegio");
    this.id_ano_lectivo = sessionStorage.getItem("id_ano_lectivo");
    this.getNiveles();
    this.getAsistenciasEstados();
    this.$store.dispatch("getAlldiasEscolares").then(() => {
      this.allowedDaysR = this.diasEscolaresColegio;
    });
  },
};
</script>